import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Login from "../pages/Login";
import { PATH } from "../constants/paths";

const isPartnerPortalPath = (pathname) =>
  pathname === PATH.PARTNER_LOGIN ||
  pathname.startsWith(`${PATH.PARTNER_LOGIN}/`);

const ProtectedRoute = () => {
  const auth = useSelector((state) => state.auth);
  const location = useLocation();
  if (auth.isLoggedIn) return <Outlet />;
  if (isPartnerPortalPath(location.pathname)) {
    return <Navigate to={PATH.PARTNER_LOGIN} replace />;
  }
  return <Login />;
};

export default ProtectedRoute;
